import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import PageLoading from "../components/PageLoading";

import { APIService } from "../http/http-common.js";
import EnrollModal2 from "../components/modals/EnrollModal2";

const BasicLayout = ({ settings, slug }) => {
  // const { slug } = useParams();
  const [loading, setLoading] = useState(false);
  const [course, setCourseData] = useState(null);
  const [popupData, setPopupData] = useState(null);

  useEffect(() => {
    document.title = `Metro Traffic School - ${slug}`;
    getCourseDatas();
  }, [slug]);

  const getCourseDatas = () => {
    setLoading(true);
    APIService.get(`/page?slug=${slug}`)
      .then((res) => {
        setCourseData(res.data.data.lessons);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const openPopup = (course) => {
    setPopupData(course);
  };

  return (
    <>
      <section className="inner-page-dui  d-flex align-items-center justify-content-center">
        {/* <div className="container">
              {!loading && course && (
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <h3>{course.name}</h3>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <div dangerouslySetInnerHTML={{ __html: course.content }}></div>
                    {course.register_url && (
                      <a
                        href={`${course.register_url}`} target="_blank" rel="noopener noreferrer"
                        className="btn yellow-btn  d-flex align-items-center justify-content-center mx-auto mt-5"
                      >
                        Get Started
                        <i className="fa-solid fa-circle-chevron-right"></i>
                      </a>
                    )}
                    <div className="phone-number text-end mt-5">
                      <a href="tel:(305) 513-0063">Call: {settings.site_phone}</a>
                      <a href="tel:1-888-41-METRO" className="mx-2">
                        <strong>{settings.site_phone_2}</strong>
                      </a>
                    </div>
                  </div>
                </div>
              
              )}
              {loading && (
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <PageLoading
                      color={"var(--metro-yellow)"}
                      classes={"justify-content-center"}
                    />
                  </div>
                </div>
              )}
            </div> */}
        <div className="overlay"></div>
        <div className="container">
          {course && course.length && (
            <div className="row position-relative dui-school-blog">
              <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-12 col-xl-12 mx-auto">
                <div className="top-course-blog ">
                  <h5 className="course-detail-heading text-capitalize mb-md-3 mb-2">
                    {course[0].name}
                  </h5>
                  <p>{course[0].short_description}</p>
                  <div className="price-detail d-flex align-items-center justify-content-center  justify-content-sm-start flex-wrap flex-sm-nowrap mb-3 mb-4">
                    <div className="detail-btn">
                      {course[0].long_description ? (
                        <a
                          onClick={() => setPopupData(course[0])}
                          className="btn small-btn d-flex align-items-center justify-content-center"
                          data-bs-toggle="modal"
                          data-bs-target="#more-info"
                        >
                          CALL TO ENROLL
                          <i className="fa-solid fa-circle-chevron-right"></i>
                        </a>
                      ) : (
                        <div className="mt-2">
                          <a
                            href={course[0].register_url}
                            style={{ minWidth: "185px", height: "55px" }}
                            target="_blank"
                            rel="noreferrer"
                            className="btn small-btn d-flex align-items-center justify-content-center"
                          >
                            Get Started
                            <i className="fa-solid fa-circle-chevron-right"></i>
                          </a>
                        </div>
                      )}
                    </div>

                    <div className="price ms-0 ms-sm-5 ms-md-5">
                      ${course[0].price}
                    </div>
                  </div>
                  {course[0] && course[0]?.course_description && (
                    <div>
                      <h2>
                        <b>COURSE DESCRIPTION</b>
                      </h2>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: course[0].course_description,
                        }}
                      ></div>
                    </div>
                  )}
                  <ul className="list-inline">
                    {!loading &&
                      course[0].features &&
                      course[0].features.some((s) => s !== null) &&
                      course[0].features.map((duiData, index) => (
                        <li
                          key={index}
                          className="list-inline-item mb-2 mb-md-3 d-flex align-items-baseline"
                        >
                          <i className="fa-solid fa-circle me-2"></i>
                          {duiData}
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
          )}
          <EnrollModal2 lessonData={popupData} />
        </div>
      </section>

      {/* {slug === "8-hour-intermediate-driver-improvement" && 
          <section className="inner-page-dui  d-flex align-items-center justify-content-center">
            <div className="overlay"></div>
              <div className="container">
                {course && course.length &&
                  <div className="row position-relative dui-school-blog">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-6 col-xl-6 mx-auto">
                      <div className="top-course-blog ">
                        <div className=" text-center">
                          <img src={course[1].icon_url} alt="icon" className="mb-md-3 mb-2 iconimg" />
                        </div>
                        <h5 className="course-detail-heading text-capitalize mb-md-3 mb-2">
                          {course[1].name}
                        </h5>
                        <p>
                          {course[1].short_description}
                        </p>
                        <div className="price-detail d-flex align-items-center justify-content-center  justify-content-sm-start flex-wrap flex-sm-nowrap mb-3 mb-4">
                          <div className="detail-btn">
                            {course[1].register_url && (
                              <a
                                href={ course[1].register_url}
                                target="_blank" rel="noopener noreferrer"
                                className="btn yellow-btn  d-flex align-items-center justify-content-center mb-4 mb-sm-0"
                              >
                                Get Started
                                <i className="fa-solid fa-circle-chevron-right"></i>
                              </a>
                            )}
                          </div>

                          <div className="price ms-0 ms-sm-5 ms-md-5">${course[1].price}</div>
                        </div>
                        <ul className="list-inline">
                          {!loading &&
                          course[1].features &&
                          course[1].features.map((duiData, index) => (
                              <li
                                key={index}
                                className="list-inline-item mb-2 mb-md-3 d-flex align-items-baseline"
                              >
                                <i className="fa-solid fa-circle me-2"></i>
                                {duiData}
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                }
              </div>
          </section>
       } */}
      {/* {slug === "12-hour-advanced-driver-improvement" && 
          <section className="inner-page-dui  d-flex align-items-center justify-content-center">
            <div className="overlay"></div>
              <div className="container">
                {course && course.length &&
                  <div className="row position-relative dui-school-blog">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-6 col-xl-6 mx-auto">
                      <div className="top-course-blog ">
                        <div className=" text-center">
                        <img src={course[2].icon_url} alt="icon" className="mb-md-3 mb-2 iconimg" />
                        </div>
                        <h5 className="course-detail-heading text-capitalize mb-md-3 mb-2">
                          {course[2].name}
                        </h5>
                        <p>
                          {course[2].short_description}
                        </p>
                        <div className="price-detail d-flex align-items-center justify-content-center  justify-content-sm-start flex-wrap flex-sm-nowrap mb-3 mb-4">
                          <div className="detail-btn">
                            {course[2].register_url && (
                              <a
                              href={ course[2].register_url}
                                target="_blank" rel="noopener noreferrer"
                                className="btn yellow-btn  d-flex align-items-center justify-content-center mb-4 mb-sm-0"
                              >
                                Get Started
                                <i className="fa-solid fa-circle-chevron-right"></i>
                              </a>
                            )}
                          </div>

                          <div className="price ms-0 ms-sm-5 ms-md-5">${course[2].price}</div>
                        </div>
                        <ul className="list-inline">
                          {!loading &&
                          course[2].features &&
                          course[2].features.map((duiData, index) => (
                              <li
                                key={index}
                                className="list-inline-item mb-2 mb-md-3 d-flex align-items-baseline"
                              >
                                <i className="fa-solid fa-circle me-2"></i>
                                {duiData}
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                }
              </div>
          </section>
       } */}
    </>
  );
};

export default BasicLayout;
